import 'whatwg-fetch';
import { Router } from 'aurelia-router';
import { HttpClient, json } from 'aurelia-fetch-client';
import { inject } from 'aurelia-framework';
import { FetchService } from './fetch-service';
import { AdvertiserService } from './advertiser-service';
import { LoggerService } from './logger-service';
import { BrowserStorageService } from './browser-storage-service';

var config = require('../../../config');

@inject(Router, FetchService, LoggerService, BrowserStorageService, AdvertiserService)
export class UserService {
    constructor(router, fetchService, logger, browserStorage, advertiserService) {
        this.router = router;
        this.fetchService = fetchService;
        this.logger = logger;
        this.browserStorage = browserStorage;
        this.advertiserService = advertiserService;
    }

    signupUser(user) {
      var customAttr = {
         role: user.role,
      };

      if(user.role !== 'AccountManager' && user.role !== 'Admin') {
         customAttr.roleKey = user.roleKey
      }

      var postData = {
         "action": "Signup",
         "params": {
            "AccessToken": this.browserStorage.storage.AccessToken,
            "ClientId": '',
            "Password": '',
            "Username": user.emailAddress,
            "UserAttributes": [
               { "Name": "given_name", "Value": user.firstName },
               { "Name": "family_name", "Value": user.lastName },
               { "Name": "email", "Value": user.emailAddress },
               { "Name": "phone_number", "Value": '+1' + user.phoneNumber.replace(/-/g, '') },
               { "Name": "custom:roles", "Value": JSON.stringify(customAttr) }
            ]
         }
      };

      if(user.AdvertiserKeys && user.AdvertiserKeys.length > 0 && user.role === 'AccountManager') {
         postData.params.AdvertiserKeys = user.AdvertiserKeys;
      }
      
      return this.post( config.userMgmtAPIGatewayUrl, JSON.stringify(postData) );
   }

    confirmSignup(emailAddress, verificationCode) {
        var postData = {
            action: 'ConfirmSignup',
            params: {
                ClientId: '',
                ConfirmationCode: verificationCode,
                ForceAliasCreation: false,
                Username: emailAddress
            }
        };

        return this.post(config.userMgmtAPIGatewayUrl, JSON.stringify(postData));
    }

    changePassword(accessToken, oldPassword, newPassword) {
        var postData = {
            action: 'ChangePassword',
            params: {
                AccessToken: accessToken,
                PreviousPassword: oldPassword,
                ProposedPassword: newPassword
            }
        };

        return this.post(config.userMgmtAPIGatewayUrl, JSON.stringify(postData));
    }

    forgotPassword(emailAddress) {
        var postData = {
            action: 'ForgotPassword',
            params: {
                Username: emailAddress
            }
        };

        return this.post(config.userMgmtAPIGatewayUrl, JSON.stringify(postData));
    }

    emailPasswordChangeConfirmation(emailAddress) {
        var postData = {
            action: 'EmailPasswordChangeConfirmation',
            params: {
                email: emailAddress
            }
        };
        return this.post(config.userMgmtAPIGatewayUrl, JSON.stringify(postData));
    }

    confirmForgotPassword(emailAddress, deltyCode, newPassword) {
        var postData = {
            action: 'ConfirmForgotPassword',
            params: {
                Username: emailAddress,
                ConfirmationCode: deltyCode,
                Password: newPassword
            }
        };

        return this.post(config.userMgmtAPIGatewayUrl, JSON.stringify(postData));
    }

    login(user) {
        this.logger.debug('login() called for user:', user);
        let that = this;
        var postData = {
            username: user.emailAddress,
            password: user.password
        };

        this.removeBrowserStorage();

        return this.post(config.userLoginAPIGatewayUrl, JSON.stringify(postData)).then(response => {
            that.logger.debug('login post returns:', response);

            if (response && response[0] !== 'Success') {
                return response;
            } else {
                that.router.auth = true;
                that.saveUserIP();

                return that.getUserInfo().then(response => {
                    that.logger.debug('getUserInfo() returns:', response);

                    if (response && response[0] === 'Success') {
                        that.router.firstName = this.browserStorage.getItem('given_name');
                    }

                    return response;
                });
            }
        });
    }

    logout(stayOnPage) {
        this.logger.debug('logout() called');
        let that = this;

        let accessToken = this.browserStorage.getItem('AccessToken');
        var postData = {
            logout: true,
            accesstoken: accessToken
        };

        return this.post(config.userLogoutAPIGatewayUrl, JSON.stringify(postData)).then(
            response => {
                that.logger.debug('logout post returns:', response);
                that.removeBrowserStorage();
                that.router.firstName = '';
                that.router.auth = false;

                if (!stayOnPage) {
                    that.router.navigate('not-authorized', {}, { replace: true, trigger: true });
                }
            }
        );
    }

    removeBrowserStorage() {
        for (var i = this.browserStorage.storage.length; i--; ) {
            this.browserStorage.storage.removeItem(this.browserStorage.storage.key(i));
        }
    }

    getUserInfo() {
        this.logger.debug('getUserInfo() called');
        let accessToken = this.browserStorage.getItem('AccessToken');
        var postData = {
            action: 'GetUserInfo',
            params: {
                AccessToken: accessToken
            }
        };

        return this.post(config.userMgmtAPIGatewayUrl, JSON.stringify(postData));
    }

    getUsers() {
        this.logger.debug('getUsers() called');
        let accessToken = this.browserStorage.getItem('AccessToken');
        var postData = {
            action: 'GetUsers',
            params: {
                AccessToken: accessToken
            }
        };

        return this.post(config.userMgmtAPIGatewayUrl, JSON.stringify(postData));
    }

    getAccountManagerAdvertisers(username) {
        this.logger.debug('getAccountManagerAdvertisers() called');
        let accessToken = this.browserStorage.getItem('AccessToken');
        var postData = {
            action: 'GetAccountManagerAdvertisers',
            params: {
                Username: username,
                AccessToken: accessToken
            }
        };

        return this.post(config.userMgmtAPIGatewayUrl, JSON.stringify(postData));
    }

    updateAccountManagerAdvertisers(username, assignedAdvertisersKeys) {
        this.logger.debug('UpdateAccountManagerAdvertisers() called');
        let accessToken = this.browserStorage.getItem('AccessToken');
        var postData = {
            action: 'UpdateAccountManagerAdvertisers',
            params: {
                Username: username,
                AdvertiserKeys: assignedAdvertisersKeys,
                AccessToken: accessToken
            }
        };

        return this.post(config.userMgmtAPIGatewayUrl, JSON.stringify(postData));
    }

    saveUserIP() {
        this.logger.debug('saveUserIP() called');
        let that = this;
        let saveIP = false;

        this.getUserIP(function (userIP) {
            if (userIP) {
                that.logger.debug('userIP', userIP);
                var postData = {
                    action: 'SaveInternalIPAddress',
                    params: {
                        UserIP: userIP
                    }
                };

                return that.post(config.userMgmtAPIGatewayUrl, JSON.stringify(postData));
            }
        });
    }

    getUserIP(callback) {
        this.logger.debug('getUserIP() called');
        let request = new XMLHttpRequest();
        request.open('GET', 'https://api.ipify.org', true);
        request.send(null);
        request.onreadystatechange = function () {
            if (request.readyState == 4) {
                return callback(request.responseText);
            } else {
                return callback();
            }
        };
    }

    redirectToPortal() {
      this.logger.debug( 'redirectToPortal() called' );
      var advertiserKey = '';
      var roles = this.browserStorage.getItem('custom:roles');
      var portal = '';

      if (roles) {
         roles = JSON.parse(roles);
         advertiserKey = roles.roleKey;

         switch (roles.role) {
            case 'AccountManager':
               portal = 'advertiserPortalLoggedIn';
               break;
            case 'Advertiser':
               portal = 'advertiserPortalLoggedIn';
               break;
            case 'Admin':
               portal = 'adminPortalLoggedIn';
               break;
            case 'Publisher':
               portal = 'publisherPortalLoggedIn';
               break;
         }
      }

      if (portal) {
         var route = this.router.routes.find(r => {
            return r.name == portal;
         });

         var url = '';
         var given_name = this.browserStorage.getItem('given_name');
         var authorization = this.browserStorage.getItem('authorization');
         var userName = this.browserStorage.getItem('Username');
         var version = this.browserStorage.getItem('custom:version');

         if (route) {
            switch (roles.role) {
               case 'AccountManager':
                  url = route.route + '/' + roles.role + '/' + given_name + '/' + userName + '/' + authorization + ((version && version != undefined && version != 'undefined')? '/' + version : '');
                  break;
               case 'Admin':
                  url = route.route + '/' + roles.role + '/' + given_name + '/' + userName + '/' + authorization + ((version && version != undefined && version != 'undefined')? '/' + version : '');
                  break;
               case 'Advertiser':
                  url = route.route + '/' + roles.role + '/' + advertiserKey + '/' + given_name + '/' + userName + '/' + authorization + ((version && version != undefined && version != 'undefined')? '/' + version : '');
                  break;
               case 'Publisher':
                  url = route.route + '/' + roles.role + '/' + advertiserKey + '/' + given_name + '/' + userName + '/' + authorization + ((version && version != undefined && version != 'undefined')? '/' + version : '');
                  break;
            }

            if(roles.role === 'AccountManager') {
               this.advertiserService.getAdvertisers().then(response => {

                  var assignedAdvertisers = {};
                  response.map(advertiser => {
                    assignedAdvertisers[advertiser.AdvertiserName] = advertiser.AdvertiserKey;
                     this.browserStorage.setItem('assignedAdvertisers', JSON.stringify(assignedAdvertisers));
                     var url = route.route + '/' + roles.role + '/' + '#' + '/' + given_name + '/' + userName + '/' + authorization + ((version && version != undefined && version != 'undefined')? '/' + version : '');
                     this.logger.debug('Redirecting to', roles.role, 'portal:', url);
                     this.router.navigate(url);
                  })
               });
            } else {
               if (url) {
                  this.logger.debug('Redirecting to', roles.role, 'portal:', url);
                  this.router.navigate(url);
               }
            }
         }
      }
   }

    post(url, postData) {
        let httpClient = new HttpClient();
        let that = this;
        let allHeaders = {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        };
        var authorize = this.browserStorage.getItem('authorization');
        if (authorize) {
            allHeaders.headers.Authorization = window.atob(authorize);
        }

        httpClient.configure(httpConfig => {
            httpConfig
                .withBaseUrl('/')
                .withDefaults({
                    headers: allHeaders.headers
                })
                .withInterceptor({
                    request(request) {
                        that.logger.debug(`Requesting ${request.method} ${request.url}`);
                        return request;
                    },
                    response(response) {
                        that.logger.debug(`Received ${response.status} ${response.url}`);
                        return response;
                    }
                });
        });

        this.logger.debug('Fetching this service request: ', postData);

        return Promise.all([
            httpClient
                .fetch(url, {
                    method: 'POST',
                    mode: 'cors',
                    body: postData,
                    credentials: 'include'
                })
                .then(response => response.json())
                .then(response => {
                    that.logger.debug('Response: ', response);

                    if (response && response.result == 'ERROR') {
                        that.logger.debug('ERROR: ' + response);
                        return 'Error';
                    } else if (response.errorMessage) {
                        return response.errorMessage;
                    } else if (response.statusCode === 400) {
                        return response.message;
                    } else {
                        // login
                        if (response.AccessToken) {
                            this.browserStorage.setItem('AccessToken', response.AccessToken);
                        }
                        if (response.auth) {
                            this.browserStorage.setItem(
                                'authorization',
                                window.btoa(response.auth)
                            );
                        }

                        // user info
                        if (response.Username && response.UserAttributes) {
                            this.browserStorage.setItem('Username', response.Username);

                            response.UserAttributes.forEach(ua => {
                                this.logger.debug('Saving user attribute: ', ua.Name, ua.Value);
                                this.browserStorage.setItem(ua.Name, ua.Value);
                                if (ua.Name == 'given_name') {
                                    this.browserStorage.setItem('firstName', ua.Value);
                                }
                            });
                        }

                        // get users
                        if(response.Users || response.Email) {
                            return response;
                        }

                        return 'Success';
                    }
                })
        ]);
    }
}
